const translations = {
  // Footer
  "footer.changeit":          "ChangeIt",
  "footer.mission":           "Our Mission",
  "footer.history":           "History",
  "footer.madewith":          "Made with",
  "footer.by":                "by",
}

export default translations;
